import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/zt_zanwushuju.png'


const _hoisted_1 = {
  key: 0,
  style: {"width":"60%","margin":"0 auto","display":"block"},
  class: "zanwushuju",
  src: _imports_0
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { style: {"margin-top":"0.4rem","margin-bottom":"0.6rem"} }

import { ref, onMounted, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import dropDown from "../../../components/comTemplate/drop-down.vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { ElMessage, ElLoading } from "element-plus";
import { WaterFall } from "../WaterFall.js"
const loading = null;

export default /*@__PURE__*/_defineComponent({
  __name: 'imageAll',
  props: {
  route_query: Object,
},
  setup(__props) {

const route = useRoute();
const top_type = ref(route.query.materialType);
const keyword = ref("");
const router = useRouter();
const props = __props;
let inputTitle = "";
document.title = "标识山西-找素材-图片素材";
router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("inputTitle")
    ? (inputTitle = router.currentRoute.value.query.inputTitle)
    : ""
  : "";

router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("keyword")
    ? (inputTitle = router.currentRoute.value.query.keyword)
    : ""
  : "";

keyword.value = inputTitle || "";
watch(
  () => route.query.keyword,
  (newData, oldData) => {
    if (newData != oldData) {
      keyword.value = newData;

      init_IMAGE();
    }
  },
  {
    immediate: false,
    deep: true,
  }
);

let pageDef = ref({
  pageNum: 1,
  pageSize: 26,
  total: 0,
});
const page = pageDef;

//头部切换页
const boxRef = ref({
  left: [
    {
      name: "类型1",
      value: "1",
      listShow: true,
      list: [
        {
          name: "实拍视频1",
          value: "1-1",
        },
      ],
    },
    {
      name: "类型2",
      value: "2",
      listShow: true,
      list: [
        {
          name: "其它",
          value: "2-1",
        },
      ],
    },
    {
      name: "版式",
      value: "3",
      listShow: true,
      list: [
        {
          name: "全部",
          value: 1,
        }, {
          name: "横版",
          value: 2,
        }, {
          name: "竖版",
          value: 3,
        }
      ],
    },
    {
      name: "格式",
      value: "4",
      listShow: true,
      list: [
        {
          name: "背景视频",
          value: "3-1",
        },
      ],
    },
  ],
  center: [
    {
      name: "价格",
      value: "5",
      listShow: true,
      width: "2.8rem",
      list: [
        {
          name: "全部",
          value: "",
          newName: "价格",
        },
        {
          name: "免费素材",
          value: [0, 0],
        },
        {
          name: "≤50元",
          value: [0, 50],
        },
        {
          name: "50-200元",
          value: [50, 200],
        },
        {
          name: "200-800元",
          value: [200, 800],
        },
        {
          name: "800元以上",
          value: [800],
        },
      ],
    },
  ],
  right: [
    {
      name: "默认排序",
      value: "9",
      listShow: true,
      list: [
        {
          name: "默认排序",
          value: "0",
        },
        {
          name: "最多下载",
          value: "1",
        },
        {
          name: "最新上传",
          value: "3",
        },
      ],
    },
  ],
});
let newTypeIdsValue5 = ref([]);
//获取图片素材格式
// Axios("get", "/fodder/ext", {}, false, (res) => {
//   console.log(res, "获取图片素材格式");
//   let data = res.data.data;
//   let arry = [];
//   data.forEach((item, index) => {
//     console.log(item);
//     arry.push({
//       name: item,
//       value: item,
//     });
//   });
//   arry.unshift({
//     name: "全部",
//     value: "",
//     newName: "格式",
//   });
//   boxRef.value.left[3].list = arry;
// });

//获取图片素材版式
// Axios("get", "/fodder/resolution-rate", {}, false, (res) => {
//   console.log(res, "获取图片素材版式");
//   let data = res.data.data;
//   let arry = [];
//   data.forEach((item, index) => {
//     console.log(item);
//     arry.push({
//       name: item,
//       value: item,
//     });
//   });
//   arry.unshift({
//     name: "全部",
//     value: "",
//     newName: "版式",
//   });
//   boxRef.value.left[2].list = arry;
// });
// 图片分类
Axios("get", "/fodder/image-types", {}, false, function (res) {
  options.value = [];
  res.data.data.forEach((item, index) => {
    item.value = item.id;
  });

  const tree = buildTree(res.data.data);
  console.log(tree);
  tree[0].listShow = true;
  tree[0].value = 1;
  boxRef.value.left[0] = tree[0];
  tree[1].value = 2;
  tree[1].listShow = true;
  boxRef.value.left[1] = tree[1];

  if (props.route_query.typeIds) {
    typeIds.value = props.route_query.typeIds;
    boxRef.value.left[props.route_query.index].name =
      props.route_query.typeIdsName;
  }
});

function buildTree(materials) {
  const tree = {};

  materials.forEach((material) => {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = {
        ...material,
        list: [],
      };
    } else {
      tree[id] = {
        ...material,
        list: tree[id].list,
      };
    }

    if (!tree[parentId]) {
      tree[parentId] = {
        list: [],
      };
    }

    tree[id].checked = false;
    tree[parentId].list.push(tree[id]);
  });
  tree[0].list.forEach((item, index) => {
    item.list.unshift(
      {
        name: "全部",
        value: "",
        newName: item.name,
      },
      {
        name: item.name,
        value: item.id,
        materialType: item.materialType,
        params: null,
        parentId: item.updateTime,
        status: "0",
        typeSort: 0,
        updateTime: item.updateTime,
        updateUser: null,
        // newName: item.name,
      }
    );
  });

  return tree[0].list;
}
let paramIndex = ref("");
let fileExt = ref("");
let resolutionRate = ref(1);
let typeIds = ref("");
let newTypeIdsValue1 = ref(""); //分类1-前端存储
let newTypeIdsValue2 = ref(""); //分类2-前端存储
const tabClick = (value, value2, item, item2, index, index_) => {
  console.log(value, value2, item, item2, index, index_, "点击子组件");
  if (value == 1 && item2) {
    boxRef.value.left[index].name = item2.newName ? item2.newName : item2.name;
    // typeIds.value = item2.value;
    newTypeIdsValue1.value = item2.value;
  }
  if (value == 2 && item2) {
    boxRef.value.left[index].name = item2.newName ? item2.newName : item2.name;
    // fileExt.value = item2.value;
    newTypeIdsValue2.value = item2.value;
  }
  if (value == 3 && item2) {
    boxRef.value.left[index].name = item2.newName ? item2.newName : item2.name;
    resolutionRate.value = item2.value;
  }
  //中间数据
  if (value == 5 && item2) {
    if (item2.newName) {
      boxRef.value.center[index].name = item2.newName;
      newTypeIdsValue5.value = "";
    } else {
      boxRef.value.center[index].name = item2.name;
      newTypeIdsValue5.value = item2.value;
    }
  }
  if (value == 4 && item2) {
    boxRef.value.left[index].name = item2.newName ? item2.newName : item2.name;
    resolutionRate.value = item2.value;
  }
  if (value == 9 && item2) {
    boxRef.value.right[index].name = item2.name;
    paramIndex.value = item2.value;
  }
  // 分类typeIds重整

  typeIds.value = "";
  if (newTypeIdsValue1.value) {
    let douhao = typeIds.value == "" ? "" : ",";
    typeIds.value = typeIds.value + douhao + newTypeIdsValue1.value;
  }
  if (newTypeIdsValue2.value) {
    let douhao = typeIds.value == "" ? "" : ",";
    typeIds.value = typeIds.value + douhao + newTypeIdsValue2.value;
  }

  init_IMAGE();
};
//访问列表
let num = 0;
const options = ref([]);
const init_IMAGE = (value1, value2) => {
  num++;
  let typeIds1 = "";
  loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  if (num == 1) {
    if (route.query.typeIds) {
      typeIds1 = route.query.typeIds;
    }
  } else {
    typeIds1 = typeIds.value;
  }
  let params = {
    // isOnline: 0,
    materialType: "IMAGE",
    paramIndex: paramIndex.value, //(排序方式（0默认1最新2热门）)
    status: 1,
    typeIds: typeIds1,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    fileExt: fileExt.value,
    // resolutionRate: resolutionRate.value,
    formatNumber: resolutionRate.value,
    keyword: keyword.value,
  };
  if (value1) {
    params["startPrice"] = value1;
    params["endPrice"] = value2;
  } else {
    if (newTypeIdsValue5.value.length != 0) {
      if (newTypeIdsValue5.value.length == 2) {
        params["startPrice"] = newTypeIdsValue5.value[0];
        params["endPrice"] = newTypeIdsValue5.value[1];
      } else {
        params["startPrice"] = newTypeIdsValue5.value[0];
      }
    }
  }

  Axios("get", "/fodder/front/list", params, false, (res) => {
    // console.log(res, '分类')
    if (res.data.rows.length == 0) {
      options.value = [];
      loading.close();
    } else {
      let new_srcList = res.data.rows;
      setTimeout(() => {
        options.value = new_srcList;
        page.value.total = res.data.total;
        nextTick(() => {
          let mwf = new WaterFall({
            id: 'forcenter',
            width: 180,
            imgUrls: res.data.rows.map((item: any) => {
              return {
                url: item.showImage,
                id: item.id,
                title: item.title,
              }
            }),
          });
          mwf.WFRender()
        });
        loading.close();
      }, 200);
    }
  });
};
//价格区间
const isDarkTime = function (value1, value2) {
  if (!value1 || !value2) {
    ElMessage({
      showClose: true,
      message: "设置范围区间有误",
      type: "warning",
    });
    return
  }
  boxRef.value.center[0].name = "价格";
  newTypeIdsValue5.value = [];
  init_IMAGE(Math.min.apply(null, [value1, value2]), Math.max.apply(null, [value1, value2]));
  // if (value1 > value2 || !value1 || !value2) {
  //   ElMessage({
  //     showClose: true,
  //     message: "设置范围区间有误",
  //     type: "warning",
  //   });
  // } else {

  // }
};
onMounted(init_IMAGE); // 在组件挂载后执行yourMethod方法
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init_IMAGE();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init_IMAGE();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init_IMAGE();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init_IMAGE();
};
//跳转详情
const detail = (id) => {
  router.push({
    path: "/ShadowMaterialVideoImage",
    query: {
      id: id,
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(dropDown, {
      onTabClick: tabClick,
      onIsDarkTime: isDarkTime,
      boxRef: boxRef.value
    }, null, 8, ["boxRef"]),
    _createElementVNode("div", null, [
      (options.value.length == 0)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
            _createElementVNode("div", {
              class: "SL_hotSongwriter_img_box",
              style: {"position":"relative","margin-top":"15px"}
            }, [
              _createElementVNode("div", {
                id: "forcenter",
                style: {"width":"100%"}
              })
            ], -1)
          ])))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (options.value.length != 0)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            "current-page": _unref(page).pageNum,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).pageNum) = $event)),
            "page-size": _unref(page).pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageSize) = $event)),
            onSizeChange: sizeChange,
            onCurrentChange: currentChange,
            style: {"margin":"0.4rem 0"},
            background: "",
            layout: "prev, pager, next",
            total: _unref(page).total
          }, null, 8, ["current-page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})